import { z } from 'zod';
import '@apexdesigner/schema-tools';
import {
  belongsTo,
  hasMany,
  hasOne,
  references,
} from '@apexdesigner/schema-tools';

export const candidate = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    status: z
      .enum(['New', 'Screening', 'Training', 'Ready', 'Placed', 'Inactive'])
      .nullable()
      .optional()
      .describe('Current status in the staffing pipeline.'),

    staffTypeId: z
      .uuid()
      .nullable()
      .optional()
      .hidden()
      .describe('Foreign key to StaffType'),

    userId: z.number().hidden().describe('Foreign key to User'),

    staffType: references('StaffType', 'staffTypeId'),

    placements: hasMany('Placement', 'candidateId'),

    classEnrollments: hasMany('ClassEnrollment', 'candidateId'),

    address: hasOne('Address', 'candidateId'),

    personalInformation: hasOne('PersonalInformation', 'candidateId'),

    identificationDocument: hasOne('IdentificationDocument', 'candidateId'),

    contactDetails: hasOne('ContactDetails', 'candidateId'),

    emergencyContact: hasOne('EmergencyContact', 'candidateId'),

    skillsAndExperience: hasOne('SkillsAndExperience', 'candidateId'),

    languageAndSkills: hasOne('LanguageAndSkills', 'candidateId'),

    eventAvailability: hasOne('EventAvailability', 'candidateId'),

    interviews: hasMany('Interview', 'candidateId'),

    user: belongsTo('User'),
  })
  .describe('A person who is being considered or prepared for event staffing.')
  .as('Candidate');

export { candidate as candidateSchema };
